module.exports ={
    "index": {
        "login": "Classement des membres",
        "regist": "Cadeau pour les nouveaux utilisateurs",
        "user": "nouvelle équipe",
        "jiang": "membre",
        "set": "Remarque",
        "lingqyu": "Aucune remarque entrée , veuillez définir",
        "liji": "n'est pas entré , veuillez le définir",
        "list": {
            "0": "Délai de dépôt",
            "1": "Informations sur la carte de débit",
            "2": "Remarque : recharge du portefeuille Bitcoin et du portefeuille USDT. 10 % gratuits du principal de la recharge + 20 USD de frais de traitement",
            "3": "Je suis désolé de ne pas l'avoir reçu , continuez à l'acheter",
            "4": "Dollar",
            "5": "Le volume de commandes le premier jour a atteint 20 et aucune autre commande ne peut être passée.",
            "6": "Soumettre maintenant"
        },
        "xuanchaun": {
            "xiazai": {
                "0": "compte bancaire",
                "1": "Annuler la commande"
            },
            "tianjia": {
                "0": "adresse",
                "1": "Aucune adresse saisie , veuillez la définir"
            },
            "tiqu": {
                "0": "Entrez s'il vous plait",
                "1": "Le solde du compte est inférieur à 200, veuillez recharger avant de passer une commande"
            }
        },
        "guanyu": {
            "title1": "Veuillez vérifier le solde du compte",
            "text1": "Solde disponible du compte insuffisant",
            "title2": "La commande a été traitée , veuillez actualiser la page",
            "text2": "Erreur de paramètre , veuillez confirmer le numéro de commande"
        },
        "title_content": {
            "0": "Le numéro de commande n'existe pas",
            "1": "Échec de la saisie de la commande . Le stock est insuffisant dans la fourchette de prix de cette catégorie.",
            "2": "La saisie de la commande a échoué ! Veuillez réessayer plus tard !"
        },
        "content": {
            "0": "Récupérez la commande avec succès",
            "1": "de la commande est insuffisant, veuillez commander à nouveau.",
            "2": "attrape le"
        },
        "dugengduo": "Solde du niveau d’adhésion insuffisant",
        "darkgrey": {
            "1": {
                "title": "La saisie des commandes a été interrompue",
                "text": "Heure d'arrivée"
            },
            "2": {
                "title": "obtenir une enveloppe rouge",
                "text": "Allez recharger"
            },
            "3": {
                "title": "Regarde encore",
                "text": "Le solde du compte doit être supérieur à 200 pour débloquer"
            },
            "4": {
                "title": "L'étape suivante",
                "text": "Le code de vérification"
            },
            "5": {
                "title": "veuillez entrer le code de vérification",
                "text": "La vérification du code de vérification graphique a échoué , veuillez ressaisir"
            },
            "6": {
                "title": "Demande réussie",
                "text": "Le format du numéro de téléphone portable est incorrect"
            }
        },
        "into": {
            "yibiaoban": "Le compte n'existe pas",
            "nihao": "L'utilisateur n'existe pas",
            "yue": "Utilisateur désactivé",
            "shebeigong": "Ce compte est déjà connecté ailleurs",
            "riqi": "Le mot de passe a été saisi incorrectement plusieurs fois de suite.",
            "gaishu": "Réessayez dans quelques minutes",
            "kaicaizong": "mauvais mot de passe",
            "xiaoshili": "connectez-vous avec succès",
            "rili": "Le code de vérification n'existe pas",
            "zhouli": "Erreur de code de vérification",
            "yeli": "Code de vérification invalide",
            "tuilian": "Le code d'invitation n'existe pas",
            "hezuo": "L'utilisateur recommandé a été désactivé",
            "fukuanxin": "Mauvaise demande",
            "tianjiadi": "S'il vous plait Connectez-vous d'abord",
            "gengxin": "Ce compte a été désactivé",
            "yibiaoti": "La fonction de trading de ce compte a été gelée",
            "yaoqing": "Ce compte a des commandes inachevées et ne peut pas continuer à récupérer des commandes.",
            "yaoqingren": "Le solde est inférieur à",
            "shijian": "Impossible de continuer à trader",
            "choujiangci": "Nombre de transactions insuffisant pour le niveau d'adhésion",
            "choujianggai": "trésor d'intérêt",
            "tuijianren": "Retrait anticipé avant l'expiration , aucun profit, les frais de traitement sont",
            "xiejie": "Le montant minimum d'investissement pour ce produit",
            "jiriqi": "Le montant maximum d'investissement pour ce produit",
            "dianjifu": "Anomalie de données",
            "tishi": {
                "1": "Solde disponible insuffisant",
                "2": "Opération réussie",
                "3": "L'opération a échoué ! Veuillez vérifier le solde de votre compte."
            },
            "chongzhijin": "Investissement de départ",
            "chongzhigai": "fonctionner",
            "nindeyu": "Transfert du solde des intérêts",
            "mianchong": "Répéter l'opération",
            "mianchongci": "Transfert du solde des intérêts",
            "chongzhili": {
                "title": "Erreur de paramètre",
                "jine": "interdit de",
                "shijian": "Effectuer l'opération en cours en dehors de la période",
                "zhauntai": "La recharge ne peut être inférieure à"
            },
            "yijiangli": "La recharge ne peut pas être supérieure à",
            "yiqizhuan": "Erreur de format d'image",
            "jianglili": "Échec de la soumission , veuillez réessayer plus tard",
            "shezhi": "Paiement WeChat",
            "mimashe": "Payer avec Ali-Pay",
            "dangqianmishu": "Retrait d'espèces WeChat",
            "xinmi": "Retrait d'espèces Alipay",
            "shuxinmi": "Aucune information de carte bancaire n'a encore été ajoutée",
            "quemi": "Aucun mot de passe de transaction défini",
            "shuquemi": "La limite de retrait du niveau d’adhésion est",
            "dainyou": "Le retrait du niveau actuel doit être terminé",
            "dianyoudi": "ordres",
            "shudainyou": "Solde insuffisant",
            "fukuanshe": "Le nombre de retraits au niveau membre est aujourd’hui insuffisant.",
            "bitedi": "Le nom du titulaire du compte est requis",
            "shugukuan": "La longueur maximale du nom du titulaire du compte est de 30 caractères.",
            "jisheng": "Le nom de la banque est requis",
            "qiangou": "Le numéro de carte bancaire est obligatoire",
            "xiacixiaoshi": "Le numéro de téléphone portable est requis",
            "yingjian": "Le numéro de carte bancaire existe déjà",
            "zonggong": "l'opération a échoué",
            "maidian": "La page n'existe pas",
            "yingjiancheng": "Obtenez des rabais",
            "zhuanzhang": "Utilisateur non connecté",
            "dianfeizong": "Veuillez ne pas soumettre à nouveau",
            "zhuanzhangti": "obtenir du succès",
            "zhaunzhangfeiyong": "échouer",
            "zuidifei": "succès",
            "tikuanjin": "Ce nom et cette carte bancaire ont été liés à un autre compte",
            "zuidixian": "Impossible de supprimer l'adresse de livraison par défaut",
            "bijieshou": "Mot de passe de connexion incorrect",
            "quezhi": "Je me suis connecté aujourd'hui",
            "querenti": "Connectez-vous avec succès et recevez une enveloppe rouge",
            "yiwen": "Connectez-vous avec succès",
            "tili": "Tous vos ordres de retrait",
            "yaohaoyou": "Vérification réussie",
            "yaohuoci": "Veuillez vous connecter pour passer une commande",
            "yihanwei": "Échec de la saisie de la commande , veuillez réessayer plus tard",
            "gongxihuo": "Échec de la saisie des commandes , inventaire de produits insuffisant"
        },
        "taocan": {
            "title": "Le numéro de portable a été enregistré",
            "text": "Un seul message texte peut être envoyé en 1 minute",
            "kuanggong": "Bien envoyé",
            "liliang": "Échec de l'envoi",
            "jiage": "SMS envoyé avec succès",
            "yingli": "Paramètres incomplets"
        },
        "baoming": {
            "title": "L'espace serveur n'est pas pris en charge . Veuillez confirmer qu'il prend en charge curl ou fsocket. Contactez votre fournisseur d'espace pour résoudre le problème ou modifier l'espace.",
            "text": "Le compte a expiré"
        }
    },
    "login": {
        "yongdeng": "Restrictions d'adresse IP",
        "quedeng": "Le contenu contient des mots sensibles",
        "yonghu": "Anomalie des paramètres du produit",
        "mima": "Le solde disponible est insuffisant , veuillez d'abord recharger",
        "xieyi": "Le montant du jour",
        "tiaokaun": "Nombre d'utilisateurs aujourd'hui",
        "tongyi": "Nombre de personnes en ligne aujourd'hui",
        "wangmi": "Année",
        "zhaomi": "lune",
        "zhaomiti": "Se connecter",
        "feihuiyuan": "continu",
        "lizhi": "Je me suis connecté aujourd'hui et j'ai reçu 1 enveloppe rouge",
        "chaunghu": "jour",
        "yonghumming": "un",
        "mimafu": "deux",
        "zhanghaoyou": "Quatre",
        "jinggao": "cinq"
    },
    "botton": {
        "lianjie": {
            "0": "six",
            "1": "Connecté",
            "2": "Déjà connecté aujourd'hui",
            "3": "transfert"
        },
        "zhichi": {
            "0": "transférer dans",
            "1": "Centre commercial"
        }
    },
    "content": {
        "zhichu": "un",
        "jiage": "De second ordre",
        "yinliang": "Aucune autorisation",
        "jiaoyizhe": "Message de configuration",
        "btbjiage": "R",
        "queren": "100",
        "quxiao": "300",
        "shehe": {
            "0": "500",
            "1": "1000",
            "2": "3000"
        }
    },
    "buchong": {
        "caidan": "5000",
        "dengchu": "10000",
        "shangdian": "30000",
        "dan": "Un compte peut être récupéré en 1 jour",
        "choujiang": "commission de génération",
        "jiangli": "Niveau 1",
        "chongzhi": "Trois générations de commissions",
        "zhuanzhang": "Niveau trois",
        "yongjin": "Télécharger la capture d'écran du paiement",
        "lijikaishi": "Tirez vers le haut pour actualiser",
        "mianfei": "Le prochain niveau de canal exclusif peut obtenir des commissions plus élevées",
        "kaishi": "Tirez vers le bas pour réorganiser",
        "lianjie": "Rabais sur les commissions subordonnées",
        "zhoumo": "Ne peux pas être vide",
        "shizhi": "Service client dédié",
        "jiaoyi": "Les mots de passe saisis deux fois sont incohérents",
        "zhichi": "Les mots de passe des fonds saisis deux fois sont incohérents",
        "fuzhi": "informations personnelles",
        "dangqian": "Afin d'empêcher la supervision de la plateforme, telle que l'appariement des commandes",
        "wanshan": "Veuillez confirmer le mot de passe de la transaction",
        "buyizhi": "Message de l'acheteur",
        "ziyou": "apprendre",
        "mai": "Commission de deuxième génération",
        "yaoqing": "Niveau 2",
        "yihan": "QR Code",
        "gongxi": "Gestion des mots de passe des transactions",
        "huifu": "Détails de la transaction"
    },
    "tanchuang": {
        "one": "Nombre de commandes prises aujourd'hui",
        "two": "Déjà saisi une commission aujourd'hui",
        "title1": "Les résultats d'aujourd'hui",
        "title2": "Les gains d'aujourd'hui"
    },
    "weishangxian": {
        "weishangxian": "Une fois l'opération ci-dessus terminée, veuillez contacter le service client pour mettre à niveau le score.",
        "yueshouru": "prix",
        "meiyuan": "Plus de tâches",
        "qianggouzhong": "salle des missions",
        "chongzhidizhi": "Remise de tâches",
        "jine": "coupon",
        "bufu": "L'adhésion est valable pour toujours",
        "zhengque": "niveau d'adhésion",
        "xuanxiang": "Détails du membre",
        "chongzhi": "Registres de dépôt et de retrait de Yu'e Bao",
        "xiaoshi": "Le revenu Yu'e Bao",
        "yongjiu": "Transfert Yu'e Bao",
        "yongjin": "Yu'e Bao est transféré",
        "renshu": "Yu'E Bao",
        "hezuo": "paiement du solde",
        "fenxiang": "Transfert de solde",
        "chenggong": "équilibre",
        "tuijianID": "Bonjour , afin de protéger vos droits et intérêts, veuillez lier le numéro de carte correct et les informations de succursale des quatre grandes banques (Banque de Chine, Construction, Industrie et Commerce, Agriculture) Si vous remplissez des informations erronées et que le compte ne peut pas le faire. être reçu, cette plateforme n'assumera aucune responsabilité ! Cette plateforme ne prend pas en charge les retraits d'espèces auprès des banques autres que les quatre grandes banques.",
        "neirong": "Commission plus",
        "tuijian": "Taux de commission"
    },
    "into_one": {
        "yibiaoban": "commission",
        "nihao": "Enregistrer le code QR dans le code de numérisation local",
        "yue": "Enregistré avec succès",
        "shebeigong": "Enregistrez des captures d'écran et scannez le code QR pour payer",
        "riqi": "Annonce d'information",
        "gaishu": "Modifier le nom",
        "kaicaizong": "changer le mot de passe",
        "xiaoshili": "Modification réussie",
        "rili": "Yuan",
        "zhouli": "Recharge",
        "yeli": "Rechargement , veuillez actualiser le solde plus tard",
        "tuilian": "Recharger et mettre à niveau",
        "hezuo": "Statut de recharge",
        "fukuanxin": "Mettre à niveau pour débloquer",
        "tianjiadi": "Rechargez pour débloquer",
        "gengxin": "Recharger la commande en attente de paiement",
        "yibiaoti": "Recharger l'enregistrement",
        "yaoqing": "Instructions de recharge",
        "yaoqingren": "Veuillez contacter le service client pour la recharge",
        "shijian": "Montant de la recharge",
        "choujiangci": "recharger",
        "choujianggai": "Recharger .",
        "tuijianren": "inscription gratuite",
        "xiejie": "Nous travaillons dur pour récupérer les commandes et les résultats seront publiés ci-dessous.",
        "jiriqi": "tous les produits",
        "dianjifu": "Tout retirer",
        "tishi": {
            "1": "tous",
            "2": "Gelé",
            "3": "Si la soumission n'est pas confirmée dans les minutes, le système gelera le montant de la commande."
        },
        "chongzhijin": "indiquer",
        "chongzhigai": "supprimer",
        "nindeyu": "Heure d'arrivée : 5 minutes",
        "mianchong": "actifs disponibles restants",
        "mianchongci": "chargement",
        "chongzhili": {
            "title": "mise à jour réussie",
            "jine": "Aller au téléchargement",
            "shijian": "Allez prendre une commande",
            "zhauntai": "Allez ajouter"
        },
        "yijiangli": "Envoyer le code de vérification",
        "yiqizhuan": "Annuler",
        "jianglili": "Solde disponible",
        "shezhi": "Solde disponible",
        "mimashe": "traités",
        "dangqianmishu": "coopérer",
        "xinmi": "nom",
        "shuxinmi": "Entrez l'état de délai d'attente après",
        "quemi": "marchandise",
        "shuquemi": "Page d'accueil du centre commercial",
        "dainyou": "Retour à la page d'accueil",
        "dianyoudi": "Taille de l'équipe",
        "shudainyou": "Equilibre de l'équipe",
        "fukuanshe": "Statut des commissions d'équipe",
        "bitedi": "Commission totale de l'équipe",
        "shugukuan": "Recharge totale de l'équipe",
        "jisheng": "Retrait total de l'équipe",
        "qiangou": "Commission de commande d'équipe",
        "xiacixiaoshi": "Rapports d'équipe",
        "yingjian": "Flux d'équipe",
        "zonggong": "Gestion d'équipe",
        "maidian": "équipe",
        "yingjiancheng": "Ouvrir dans le navigateur",
        "zhuanzhang": "Paiement en ligne",
        "dianfeizong": "zone",
        "zhuanzhangti": "Copié avec succès",
        "zhaunzhangfeiyong": "Copier le lien",
        "zuidifei": "cloner",
        "tikuanjin": "ciel",
        "zuidixian": "Paramètres de l'avatar",
        "bijieshou": "avatar",
        "quezhi": "Si vous rencontrez des problèmes et avez besoin d'aide, veuillez contacter le service client en ligne",
        "querenti": "Nom",
        "yiwen": "déposer une somme",
        "tili": "Le montant du dépôt ne répond pas aux exigences du système",
        "yaohaoyou": "dépôts",
        "yaohuoci": "accéder à l'historique",
        "yihanwei": "garantie officielle",
        "gongxihuo": "Officiellement fourni"
    },
    "into_two": {
        "yibiaoban": "Gestion financière régulière",
        "nihao": "Certainement",
        "yue": "Échec de l'audit",
        "shebeigong": "examen réussi",
        "riqi": "Service client",
        "gaishu": "service client",
        "kaicaizong": "réseau",
        "xiaoshili": "Gestion des mots de passe",
        "rili": "Cher utilisateur, afin d'assurer la sécurité de vos fonds, veuillez lier votre vrai nom et définir un mot de passe de retrait. Si le nom ne correspond pas au nom d'ouverture du compte, le retrait ne sera pas possible",
        "zhouli": "Le point décimal doit être renseigné",
        "yeli": "heures, le système se débloquera automatiquement après l'expiration",
        "tuilian": "Faites glisser votre doigt vers la gauche ou la droite pour en voir plus",
        "hezuo": "A été envoyé",
        "fukuanxin": "complété",
        "tianjiadi": "Révoqué",
        "gengxin": "Veuillez entrer votre email",
        "yibiaoti": "Vous avez déjà un compte? S'identifier",
        "yaoqing": "Vous avez déjà un compte, téléchargez maintenant",
        "yaoqingren": "expiré",
        "shijian": "passé",
        "choujiangci": "Rejeté",
        "choujianggai": "Commencez votre chemin vers la richesse",
        "tuijianren": "Titulaire de compte",
        "xiejie": "Convention d'ouverture de compte",
        "jiriqi": "Nom du compte",
        "dianjifu": "Adresse d'ouverture de compte",
        "tishi": {
            "1": "Banque d'ouverture de compte",
            "2": "Banque de dépôt",
            "3": "Revenu du jour"
        },
        "chongzhijin": "En attente de paiement",
        "chongzhigai": "En attente",
        "nindeyu": "En attendant l'examen",
        "mianchong": "Être payé",
        "mianchongci": "En attente du reçu",
        "chongzhili": {
            "title": "A débloquer",
            "jine": "Vous pouvez directement appuyer longuement pour identifier le code QR sur WeChat",
            "shijian": "oublier le mot de passe",
            "zhauntai": "Retrait d'argent rapide"
        },
        "yijiangli": "Recharge totale",
        "yiqizhuan": "Total des retraits",
        "jianglili": "Revenu total",
        "shezhi": "Actif total",
        "mimashe": "votre solde",
        "dangqianmishu": "Votre commande sera passée le",
        "xinmi": "Votre commande a été gelée , veuillez patienter",
        "shuxinmi": "Votre commande a expiré et ne peut pas être traitée",
        "quemi": "vos informations d'identité",
        "shuquemi": "Les informations de votre carte bancaire",
        "dainyou": "Êtes-vous sûr de vouloir supprimer cette adresse ?",
        "dianyoudi": "Vous n'avez pas encore ajouté les informations de votre carte bancaire",
        "shudainyou": "J'ai accepté le \"Contrat de service\"",
        "fukuanshe": "J'ai effectué le paiement",
        "bitedi": "J'ai compris et accepté",
        "shugukuan": "Mon solde",
        "jisheng": "mon équipe",
        "qiangou": "mon actif total",
        "xiacixiaoshi": "mon numéro de portable",
        "yingjian": "Ma commande",
        "zonggong": "Mon sac à main",
        "maidian": "Ma carte de débit",
        "yingjiancheng": "le mien",
        "zhuanzhang": "Capture d'écran ou directement",
        "dianfeizong": "Banque",
        "zhuanzhangti": "Tout va bien",
        "zhaunzhangfeiyong": "tous les types",
        "zuidifei": "Le numéro de téléphone portable est erroné",
        "tikuanjin": "Numéro de téléphone portable mal saisi",
        "zuidixian": "numéro de téléphone",
        "bijieshou": "Numéro de téléphone",
        "quezhi": "téléphone portable",
        "querenti": "frais de gestion",
        "yiwen": "Prendre une commande",
        "tili": "Temps de prise de commande",
        "yaohaoyou": "Numéro de commande",
        "yaohuoci": "Registre des commandes de saisie",
        "yihanwei": "Enregistrer",
        "gongxihuo": "Instructions de saisie des commandes"
    },
    "into_s1": {
        "yibiaoban": "prendre une commande",
        "nihao": "Quantité commandée",
        "yue": "Remise de commission pour la prise de commande",
        "shebeigong": "affiche promotionnelle",
        "riqi": "Nombre de personnes recommandé",
        "gaishu": "Produits recommandés",
        "kaicaizong": "recommander",
        "xiaoshili": "soumission",
        "rili": "Soumission réussie , veuillez attendre patiemment l'examen",
        "zhouli": "Soumission réussie , sera bientôt redirigé",
        "yeli": "Soumettre la commande",
        "tuilian": "soumettre",
        "hezuo": "Nombre de retraits",
        "fukuanxin": "Statut de retrait",
        "tianjiadi": "La demande de retrait a été soumise",
        "gengxin": "Registre des retraits",
        "yibiaoti": "Taux de retrait",
        "yaoqing": "Montant de retrait",
        "yaoqingren": "Limite de retrait",
        "shijian": "retirer",
        "choujiangci": "recherche",
        "choujianggai": "mode de paiement",
        "tuijianren": "Adresse de la succursale",
        "xiejie": "destinataire",
        "jiriqi": "Bénéficiaire",
        "dianjifu": "norme de revenu",
        "tishi": {
            "1": "Type de prestation",
            "2": "Record de gains",
            "3": "Le nom du destinataire"
        },
        "chongzhijin": "Informations sur l'adresse de livraison",
        "chongzhigai": "Modification de l'adresse de livraison",
        "nindeyu": "Modifier l'adresse de livraison",
        "mianchong": "Adresse de livraison",
        "mianchongci": "Réception d'informations d'identité",
        "chongzhili": {
            "title": "De nouvelles personnes",
            "jine": "nouveau mot de passe",
            "shijian": "Nouveau numéro de portable",
            "zhauntai": "temps"
        },
        "yijiangli": "Commission d’équipe d’hier",
        "yiqizhuan": "Les gains d'hier",
        "jianglili": "Pas de données",
        "shezhi": "Pas encore d'enregistrement",
        "mimashe": "Plus d'information",
        "dangqianmishu": "Plus",
        "xinmi": "La carte bancaire n'est pas liée , allez la lier",
        "shuxinmi": "Aucune région saisie, veuillez la définir",
        "quemi": "La banque d'ouverture du compte n'est pas renseignée, veuillez la paramétrer",
        "shuquemi": "Adresse de la succursale non saisie, veuillez la définir",
        "dainyou": "Aucun numéro de téléphone saisi, veuillez le définir",
        "dianyoudi": "Aucun numéro de téléphone saisi, veuillez le définir",
        "shudainyou": "Aucun vrai nom saisi, veuillez le définir",
        "fukuanshe": "Aucune adresse détaillée saisie, veuillez la définir",
        "bitedi": "Aucun numéro de carte bancaire renseigné, merci de le renseigner",
        "shugukuan": "n'est pas saisi , veuillez le définir",
        "jisheng": "Ces données sont fournies par",
        "qiangou": "Les frais de dossier seront déduits pour ce retrait.",
        "xiacixiaoshi": "Chargement",
        "yingjian": "Peut prendre des commandes tous les jours",
        "zonggong": "Il n'y a pas de code QR , veuillez cliquer",
        "maidian": "pas de données",
        "yingjiancheng": "Plus de contenu",
        "zhuanzhang": "Plus de données",
        "dianfeizong": "Aucun enregistrement",
        "zhuanzhangti": "Heure d'inscription",
        "zhaunzhangfeiyong": "registre",
        "zuidifei": "Remarque : en raison de la grande quantité d'informations de recharge, assurez-vous de vérifier soigneusement le numéro de carte de compte avant de recharger. Cette plateforme change de compte de temps en temps. Si vous avez des questions, veuillez cliquer sur le service client en ligne.",
        "tikuanjin": "centre d'activités",
        "zuidixian": "Nombre de personnes actives",
        "bijieshou": "Nouvelle adresse de livraison",
        "quezhi": "Conseils aimables",
        "querenti": "État",
        "yiwen": "Recharge utilisateur",
        "tili": "Le nom d'utilisateur ne peut pas être vide",
        "yaohaoyou": "Erreur de saisie du nom d'utilisateur , nécessite 2 à 12 lettres ou chiffres",
        "yaohuoci": "L'utilisateur prend les commandes",
        "yihanwei": "Retrait de l'utilisateur",
        "gongxihuo": "numéro de téléphone"
    },
    "into_f": {
        "yibiaoban": "Mot de passe",
        "nihao": "Se connecter",
        "yue": "Directement sous",
        "shebeigong": "Directement sous",
        "riqi": "nom réel",
        "gaishu": "Confirmer la modification",
        "kaicaizong": "Confirmer la liaison de la carte",
        "xiaoshili": "Bien sûr",
        "rili": "Confirmer la recharge",
        "zhouli": "Confirmez-vous l'annulation ? L'annulation entraînera le gel du montant.",
        "yeli": "Confirmez le mot de passe",
        "tuilian": "Confirmer pour retirer ce montant sur le solde ? Aucun intérêt ne sera calculé sur les retraits indus ! , et déduire",
        "hezuo": "Confirmer pour sortir ?",
        "fukuanxin": "Revenir à ma page en quelques secondes",
        "tianjiadi": "Deuxième",
        "gengxin": "Retirer immédiatement",
        "yibiaoti": "Acheter maintenant",
        "yaoqing": "mettre à niveau immédiatement",
        "yaoqingren": "Configurer maintenant",
        "shijian": "En attente de confirmation de l'acheteur",
        "choujiangci": "En attente de confirmation de l'acheteur",
        "choujianggai": "En attente de la réponse du système marchand",
        "tuijianren": "filtre",
        "xiejie": "Introduction",
        "jiriqi": "notification du système",
        "dianjifu": "Le système est basé sur la technologie LBS et associe automatiquement les produits via le cloud.",
        "tishi": {
            "1": "Compte système",
            "2": "Revenu cumulé",
            "3": "Recharge en ligne"
        },
        "chongzhijin": "Recharge hors ligne",
        "chongzhigai": "Lier le numéro de téléphone mobile",
        "nindeyu": "Lier une carte bancaire",
        "mianchong": "statistiques",
        "mianchongci": "Modifier l'adresse de livraison",
        "chongzhili": {
            "title": "Modifier la carte de débit",
            "jine": "modifier",
            "shijian": "Le réseau n'est pas stable , veuillez réessayer dans un endroit avec un meilleur signal",
            "zhauntai": "Le réseau est instable , veuillez réessayer dans un endroit avec un meilleur signal"
        },
        "yijiangli": "Numéro de contact",
        "yiqizhuan": "Allez prendre une commande",
        "jianglili": "automatique",
        "shezhi": "Calcul automatique",
        "mimashe": "Centre commercial autogéré",
        "dangqianmishu": "à",
        "xinmi": "Obtenir le code de vérification",
        "shuxinmi": "règle",
        "quemi": "Ouvrir",
        "shuquemi": "numéro de commande",
        "dainyou": "La commande a été gelée et le temps de dégel est",
        "dianyoudi": "La commande a expiré",
        "shudainyou": "Le montant total des commandes",
        "fukuanshe": "Total de la commande",
        "bitedi": "La commande est en cours de soumission",
        "shugukuan": "Commandes soumises avec succès",
        "jisheng": "détails de la commande",
        "qiangou": "Commande",
        "xiacixiaoshi": "Se souvenir du mot de passe",
        "yingjian": "Définir comme adresse commune",
        "zonggong": "Définir par défaut",
        "maidian": "Définir l'avatar",
        "yingjiancheng": "Détails",
        "zhuanzhang": "Adresse",
        "dianfeizong": "Veuillez télécharger le bon de paiement",
        "zhuanzhangti": "Veuillez télécharger le bon de recharge",
        "zhaunzhangfeiyong": "Veuillez vérifier attentivement les informations de paiement",
        "zuidifei": "payez s'il vous plait",
        "tikuanjin": "Veuillez changer votre nom",
        "zuidixian": "Assurez-vous de conserver le montant du transfert avec des points décimaux pour éviter d'affecter le temps de recharge.",
        "bijieshou": "Veuillez transférer et recharger sur le compte suivant",
        "quezhi": "Veuillez consulter le service client en ligne après avoir terminé la recharge",
        "querenti": "Veuillez remplir le nom de la recharge",
        "yiwen": "Veuillez renseigner le numéro de téléphone portable de recharge",
        "tili": "Veuillez renseigner le montant de la recharge",
        "yaohaoyou": "Veuillez remplir votre nom",
        "yaohuoci": "veuillez remplir le numéro de téléphone portable",
        "yihanwei": "Veuillez remplir le bon numéro de téléphone portable",
        "gongxihuo": "Veuillez remplir l'adresse détaillée"
    },
    "into_s": {
        "yibiaoban": "Veuillez remplir l'adresse de livraison détaillée",
        "nihao": "N'oubliez pas votre mot de passe . Si vous oubliez votre mot de passe, veuillez contacter le service client.",
        "yue": "Veuillez demander au service client en ligne (la plateforme change de compte de temps en temps)",
        "shebeigong": "Veuillez saisir le mot de passe de la transaction",
        "riqi": "Veuillez saisir le montant de la recharge",
        "gaishu": "Veuillez saisir le mot de passe d'origine",
        "kaicaizong": "Veuillez entrer le mot de passe",
        "xiaoshili": "Veuillez saisir le nom du titulaire du compte",
        "rili": "Veuillez saisir le numéro de téléphone portable du titulaire du compte",
        "zhouli": "Veuillez saisir l'adresse de la banque d'ouverture du compte",
        "yeli": "Veuillez saisir la banque d'ouverture du compte",
        "tuilian": "Veuillez indiquer la banque où le compte est ouvert",
        "hezuo": "Veuillez entrer votre nouveau mot de passe",
        "fukuanxin": "Veuillez entrer le numéro de téléphone",
        "tianjiadi": "Veuillez saisir le code de vérification du téléphone mobile",
        "gengxin": "Veuillez entrer le code de parrainage",
        "yibiaoti": "Veuillez saisir le montant du retrait",
        "yaoqing": "Veuillez saisir le nom du destinataire",
        "yaoqingren": "Veuillez entrer un nouveau mot de passe",
        "shijian": "Veuillez saisir votre numéro de téléphone portable ou votre adresse e-mail",
        "choujiangci": "veuillez entrer le nom d'utilisateur",
        "choujianggai": "Veuillez entrer votre mot de passe de connexion",
        "tuijianren": "Veuillez saisir le code de vérification SMS",
        "xiejie": "Veuillez entrer votre compte /mot de passe",
        "jiriqi": "Veuillez saisir le mot de passe du fonds",
        "dianjifu": "Veuillez saisir le montant du transfert",
        "tishi": {
            "1": "Veuillez entrer le code d'invitation",
            "2": "Veuillez saisir le numéro de votre carte bancaire",
            "3": "veuillez entrer le code de vérification"
        },
        "chongzhijin": "Veuillez sélectionner le canal de paiement",
        "chongzhigai": "Veuillez sélectionner le canal de paiement",
        "nindeyu": "Veuillez sélectionner l'adresse de livraison",
        "mianchong": "Veuillez sélectionner le niveau vers lequel vous souhaitez passer",
        "mianchongci": "solde du compte",
        "chongzhili": {
            "title": "Montant du compte gelé",
            "jine": "Détails du compte",
            "shijian": "Montant du compte",
            "zhauntai": "Produit de l'achat"
        },
        "yijiangli": "Achetez sans entrer votre vrai nom, veuillez le configurer",
        "yiqizhuan": "Lors de l'achat de produits financiers , les bénéfices ne seront pas calculés pour les achats malveillants et des frais de traitement seront facturés.",
        "jianglili": "Acheter",
        "shezhi": "Mot de passe du fonds",
        "mimashe": "Redirection",
        "dangqianmishu": "Pour transférer de l'argent, veuillez copier le message et accéder à la banque en ligne ou à Alipay pour finaliser le transfert et recharger.",
        "xinmi": "Entrez le montant de la recharge",
        "shuxinmi": "Entrez le nom",
        "quemi": "Entrez le montant du dépôt",
        "shuquemi": "saisir le numéro de téléphone portable",
        "dainyou": "Entrez le mot de passe du fonds",
        "dianyoudi": "De retour",
        "shudainyou": "retour",
        "fukuanshe": "Aucune adresse de récolte n'a encore été ajoutée",
        "bitedi": "Aucune carte bancaire ajoutée pour l'instant",
        "shugukuan": "Entrez dans le magasin et jetez un oeil",
        "jisheng": "L'hôte distant alloue",
        "qiangou": "se déconnecter",
        "xiacixiaoshi": "Choisissez la méthode de recharge",
        "yingjian": "Choisissez la méthode de retrait",
        "zonggong": "Sélectionnez la quantité",
        "maidian": "Choisissez des produits financiers",
        "yingjiancheng": "Inviter des amis",
        "zhuanzhang": "Rejoignez-nous pour obtenir plus d'avantages",
        "dianfeizong": "Code d'invitation",
        "zhuanzhangti": "Lien d'invitation : cliquez pour copier",
        "zhaunzhangfeiyong": "Veuillez vérifier attentivement les informations de paiement",
        "zuidifei": "Retrait d'espèces par carte financière",
        "tikuanjin": "Compte de carte de débit",
        "zuidixian": "carte bancaire",
        "bijieshou": "Nom de banque",
        "quezhi": "question",
        "querenti": "Si vous avez besoin d'aide, vous pouvez contacter le service client pour recharger manuellement.",
        "yiwen": "Il faut rembourser",
        "tili": "Revenu estimé",
        "yaohaoyou": "Retour attendu",
        "yaohuoci": "Nombre de personnes effectuant leur premier dépôt",
        "yihanwei": "page de garde",
        "gongxihuo": "Rechargez maintenant"
    },
    "into_se": {
        "yibiaoban": "Le code de vérification",
        "nihao": "défaut",
        "yue": "Veuillez prendre manuellement une capture d'écran de l'application et l'enregistrer localement pour scanner le code QR.",
        "shebeigong": "Veuillez utiliser l'application manuellement",
        "riqi": "Maison",
        "gaishu": "Mot de passeConnexion",
        "kaicaizong": "Pas encore soumis",
        "xiaoshili": "succès de l'inscription",
        "rili": "Peut être mis à niveau",
        "zhouli": "Impossible de mettre à niveau",
        "yeli": "Impossible de mettre à niveau si les conditions de mise à niveau ne sont pas remplies",
        "tuilian": "Vous avez atteint les critères de mise à niveau et avez terminé la mise à niveau",
        "hezuo": "notification du système",
        "fukuanxin": "Solde utilisateur insuffisant",
        "tianjiadi": "Pas assez d'utilisateurs invités",
        "gengxin": "Les conditions de mise à niveau ne sont pas remplies",
        "yibiaoti": "Le solde du compte requis est supérieur à",
        "yaoqing": "inviter",
        "yaoqingren": "déverouiller",
        "shijian": "adresse du portefeuille",
        "choujiangci": "Scan de portefeuille disponible pour le transfert",
        "choujianggai": "Commission d'équipe aujourd'hui",
        "tuijianren": "Téléchargement de l'application",
        "xiejie": "Bonus de recharge",
        "jiriqi": "Veuillez saisir l'adresse TRC20",
        "dianjifu": "Veuillez saisir l'adresse ERC20",
        "tishi": {
            "1": "à propos de nous",
            "2": "agent",
            "3": "règle"
        },
        "chongzhijin": "introduire",
        "chongzhigai": "Qualification",
        "nindeyu": "Surprise à l'ouverture du coffret cadeau",
        "mianchong": "Gagnez de l'argent immédiatement",
        "mianchongci": "ancien mot de passe",
        "chongzhili": {
            "title": "Veuillez saisir l'ancien mot de passe",
            "jine": "Veuillez saisir à nouveau le mot de passe",
            "shijian": "le mot de passe a été mis à jour",
            "zhauntai": "Échec de la modification du mot de passe"
        },
        "yijiangli": "Veuillez cocher la case pour accepter l'accord",
        "yiqizhuan": "Vous avez atteint les critères de mise à niveau et avez été automatiquement mis à niveau",
        "jianglili": "Déclassé en raison d'un changement d'équilibre",
        "shezhi": "notification du système",
        "mimashe": "ordre de négociation",
        "dangqianmishu": "Le paiement a été forcé par le système. Si vous avez des questions, veuillez contacter le service client.",
        "xinmi": "Activer la saisie automatique des commandes",
        "shuxinmi": "Désactiver la saisie automatique des commandes",
        "quemi": "Nom d'utilisateur en double",
        "shuquemi": "Déclassé en raison d'un changement d'équilibre",
        "dainyou": "Vous avez atteint les critères de mise à niveau et avez été automatiquement mis à niveau",
        "dianyoudi": "Téléphone",
        "shudainyou": "à propos de nous",
        "fukuanshe": "Voir maintenant",
        "bitedi": "plate-forme",
        "shugukuan": "annonce",
        "jisheng": "Invitez des amis à gagner de l'argent",
        "chongxindenglu": "Veuillez vous reconnecter",
        "pingtaijianjie": "Présentation de la plateforme",
        "pingtaijianjie1": "Règles de saisie des commandes",
        "pingtaijianjie2": "Coopération entre agences",
        "pingtaijianjie3": "Qualifications de l'entreprise"
    },
    "qing_sd": "S'il vous plaît, attendez",
    "loading1": "procuration en ligne",
    "loading2": "demander une commande",
    "loading3": "Prendre une commande",
    "goods": {
        "0": "verre vert",
        "1": "Produits de soins exclusifs",
        "2": "Gobelet en plastique de qualité alimentaire",
        "3": "parfum classique",
        "4": "grains de café importés",
        "5": "Ours style Disney"
    },
    "tab_name": {
        "0": "page de garde",
        "1": "Dossier de commande",
        "2": "Commander",
        "3": "service client",
        "4": "le mien"
    },
    "pingjia": "évaluer",
    "login_t1": "One-stop shop for shopping around the world and earning rebates",
    "zhangh": "Veuillez saisir votre téléphone portable",
    "email": "E-mail",
    "use_app": "Utiliser l'application",
    "index_t1": "30 % de réduction supplémentaire + 10 % de remise en argent + livraison gratuite sur votre premier achat d'application. Les conditions générales s'appliquent.",
    "qianbao": "portefeuille",
    "huoqu_yj": "Obtenez des commissions",
    "zhangh_ye": "Solde du compte",
    "zhangh_je": "solde du compte",
    "huoq_yj": "Obtenez des commissions",
    "dingd_s": "quantité de commande",
    "caoz_bz": "Pas",
    "caoz_t1": "1. Cliquez sur le bouton Démarrer la tâche et suivez les invites pour terminer la tâche.",
    "caoz_t2": "2. Après avoir terminé la tâche, vous pouvez régler la commission sur le solde",
    "kefu_t1": "Si vous avez des questions ou besoin d'aide,",
    "kefu_t2": "Veuillez contacter le service client en ligne pour résoudre le problème pour vous",
    "kefu_t3": "Votre service client dédié",
    "changj_wtjd": "Questions fréquemment posées",
    "changj_wt": {
        "0": {
            "name": "Comment recharger et quels moyens de paiement sont disponibles ?",
            "value": "Ce système est ouvert à plusieurs pays et les méthodes de paiement internationales que nous proposons incluent : USDT (ERC20). Dans le même temps, nous soutenons également les monnaies nationales de différents pays."
        },
        "1": {
            "name": "Comment puis-je investir et gagner un revenu ?",
            "value": "Vous pouvez participer aux transactions sur matières premières dans le système et obtenir chaque jour des revenus de transaction stables. Tous les revenus peuvent être retirés sur votre carte bancaire."
        },
        "2": {
            "name": "Comment s'inscrire comme membre ?",
            "value": "Un système d'invitation est utilisé pour enregistrer de nouveaux membres. Afin de garantir les revenus des membres enregistrés et d'éviter que les inscriptions excessives ne réduisent les revenus, les nouveaux membres ne peuvent s'inscrire que sur invitation des membres existants."
        },
        "3": {
            "name": "Y a-t-il une limite au montant d'achat ?",
            "value": "Oui, afin de donner à davantage de membres la possibilité de réaliser des bénéfices, chaque compte du système a une limite d'achat minimum."
        }
    },
    "yonghu_m": "nom d'utilisateur",
    "shoukuan_zh": "Comptes débiteurs",
    "youxiang": "Mail",
    "zhanghao": "compte",
    "xiugai_mima": "changer le mot de passe",
    "xuanze_yy": "Choisissez une langue",
	queren:'confirmer',
	bangka:'Veuillez lier le compte de paiement',
	xingy_d:'Félicitations, vous avez décroché une commande chanceuse'
}